/**
 * "Your page" (`/pages`): the contractor's own place in the portal for the
 * page we host (owner decision 2026-10-20: the page used to live only under
 * Sites & keys as "Widget pages", with no nav item). The list and create form
 * are HostedPagePanel.tsx, the same panel onboarding mounts; under it, what it
 * costs and what still stands between the page and a lead (LeadReadiness).
 */
import { useState } from 'react';
import type { HostedPage } from '../api/types';
import { FeeSummary } from '../legal/FeeSummary';
import { LeadReadiness } from '../hostedPage/LeadReadiness';
import { PageHead } from '../ui/kit';
import { HostedPagePanel } from './HostedPagePanel';

export function Pages() {
  const [pages, setPages] = useState<HostedPage[] | null>(null);
  const first = pages?.find((p) => p.enabled) ?? pages?.[0] ?? null;
  return (
    <>
      <PageHead title="Your page" lede="Share it, print the QR code, and keep it complete. Changes show within a minute." />
      <div className="stack-lg" style={{ minWidth: 0 }}>
        <HostedPagePanel onPagesChange={setPages} />
        <FeeSummary />
        {first ? <LeadReadiness slug={first.slug} /> : null}
      </div>
    </>
  );
}
